

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { CommentoDTO } from "../dto/commentoDTO";
import { CommentoVO } from "../vo/commentoVO";
import { MapperUtente } from "./mapper-utente";




@Injectable({
    providedIn: 'root'
})
export class MapperCommento implements MapperInterface<CommentoDTO, CommentoVO> {

    constructor(
        private mapperUtente: MapperUtente
    ) {

    }

    convertVoToDto(vo: CommentoVO): CommentoDTO {
        if (vo != null) {
            const dto = new CommentoDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.autore = this.mapperUtente.convertVoToDto(vo.autore);
            dto.data = vo.data;
            dto.testo = vo.testo;
            dto.id = vo.id;
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: CommentoDTO): CommentoVO {
        if (dto != null) {
            const vo = new CommentoVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.autore = this.mapperUtente.convertDtoToVo(dto.autore);
            vo.data = dto.data;
            vo.testo = dto.testo;
            vo.id = dto.id;

            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: CommentoVO[]): CommentoDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: CommentoDTO[]): CommentoVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
